import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["focusRef"];
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import styled from 'styled-components';
import { Button } from '@frameio/vapor';
var StyledButton = styled(Button).withConfig({
  displayName: "LinkButton__StyledButton",
  componentId: "@frameio/developer-components__sc-18ffedr-0"
})({
  color: '#666a72',
  textTransform: 'uppercase',
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '18px',
  letterSpacing: '1.114285945892334px',
  textAlign: 'right',
  marginLeft: '20px',
  ':first-child': {
    marginLeft: '0px'
  }
});

var LinkButton = function LinkButton(_ref) {
  var focusRef = _ref.focusRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    variant: "link",
    color: "primary"
  }, props, {
    ref: focusRef
  }));
};

export default LinkButton;